package com.clany.backoffice.data.local

import kotlinx.browser.localStorage


import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.ContributesBinding
import com.clany.backoffice.di.AppScope
import dev.zacsweers.metro.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class)
@Inject
class BrowserTokenStorage : TokenStorage {
    private val _authState = MutableStateFlow(localStorage.getItem("access_token") != null)
    override val authState: StateFlow<Boolean> = _authState.asStateFlow()
    override fun saveToken(token: String) {
        localStorage.setItem("access_token", token)
        _authState.value = true
    }

    override fun getToken(): String? {
        return localStorage.getItem("access_token")
    }

    override fun saveRefreshToken(token: String) {
        localStorage.setItem("refresh_token", token)
    }

    override fun getRefreshToken(): String? {
        return localStorage.getItem("refresh_token")
    }

    override fun saveExpiresIn(expiresIn: Long) {
        localStorage.setItem("expires_in", expiresIn.toString())
    }

    override fun getExpiresIn(): Long? {
        return localStorage.getItem("expires_in")?.toLongOrNull()
    }

    override fun saveRefreshExpiresIn(expiresIn: Long) {
        localStorage.setItem("refresh_expires_in", expiresIn.toString())
    }

    override fun getRefreshExpiresIn(): Long? {
        return localStorage.getItem("refresh_expires_in")?.toLongOrNull()
    }

    override fun saveIdToken(token: String) {
        localStorage.setItem("id_token", token)
    }

    override fun getIdToken(): String? {
        return localStorage.getItem("id_token")
    }

    override fun clearAll() {
        localStorage.removeItem("access_token")
        localStorage.removeItem("refresh_token")
        localStorage.removeItem("expires_in")
        localStorage.removeItem("refresh_expires_in")
        localStorage.removeItem("id_token")
        _authState.value = false
    }
}
